import UserDetails from 'admin/utils/UserDetails'
import React from 'react'

function UserdetailsPage() {
  return (
    <div className='w-11/12 mx-auto mt-3'>
        <UserDetails />
    </div>
  )
}

export default UserdetailsPage